import {
  Component,
  OnInit,
  Compiler,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';
import { HeaderCustomComponent } from '../header/headerCustom.component';
import { IfStmt } from '@angular/compiler';
@Component({
  selector: 'app-nominate',
  templateUrl: './nominate.component.html',
  styleUrls: ['./nominate.component.css'],
})
export class NominateComponent implements OnInit {
  panelOpenState = false;
  ibuList: any = [];
  ibu: any;
  functionList: any = [];
  function: any = '';
  selectedIbuId: any = null;
  towerList: any = [];
  selectedTowerId: any;
  alltowerList: any = [];
  tower: any = '';
  marked: boolean = false;
  isAppr: number;
  newNomi = '';
  attrValue = '';
  checkedEligiblity: boolean = false;
  disabledNominatiobtn: boolean = true;
  showHideModel: boolean = true;
  @ViewChild('closeModel', { read: ElementRef }) closeModel: ElementRef;
  //shruti - 8/6/2020
  userFormDetails: any;
  showEligCrtModel: boolean = false;
  nomination: boolean = false;
  errorNomination: boolean = false;
  successNominee: boolean = false;
  nomineeData: any[] = [];
  userparm: any = '';
  userFullName: string = '';
  // -------------------------
  users: any = {};
  addUserForm: any;
  config: any;
  loading: boolean = false;
  fetchData: any[] = [];
  submitted = false;
  userId: any = 0;
  loginImageURL: any = '';
  baseURL: any = null;
  loginUserName: any = '';
  // private showHideModel: boolean = true;
  skillData: any[] = [];
  //Add users form fields
  userUpdatedId: Number = 0;
  empCode: any;
  resourceName: any;
  resourceEmail: any;
  typesResource: any = 'Regular';
  joinDate: any;
  leaveDate: any;
  // private selectedTeam: any = "Engineering";
  selectedEmail: any = '';
  selectedSVEmail: any = '';
  selectedUserId: any = '';
  resourceManager: any;
  resourceManagerEmail: any;
  currentRole: any = JSON.parse(localStorage.user).userData.userRoll;
  inactiveUserCount = 0;
  activeUserCount = 0;
  skillRatingData: any[] = [];
  towerId: any;
  positionList: any = [];
  currentPositionList: any = [];
  userRoll: number = 0;
  userType: any = '';
  allPositions: any = [];
  userRole: any = JSON.parse(localStorage.user).userData.userRoll;
  whyMove: any = '';
  experience: any = '';
  lastBSC: any = '';
  nextPosition: any = '';
  otherNextPosition: any = '';
  isOtherNextRole: boolean = false;
  maxCharForWhyToMoveLength: any = 500;
  initiatedFormValue: boolean = false;
  maxLeftCharacterWhyToMove: any = this.maxCharForWhyToMoveLength;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private excelService: ExcelService,
    private commonService: CommonService,
    private common: Common,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout();
      return;
    }
    if (this.users && this.users.userData) {
      this.users = this.users.userData;

      this.loginUserName = this.users.userFullName;
      // this.users.userFullName = this.users.userFullName.toLowerCase();
      this.towerId = this.users.towerId;
    }
    if (this.users && this.users.userData) {
      if (this.users.userData.userFullName) {
        this.loginUserName = this.users.userData.userFullName;
      } else {
        this.loginUserName = this.users.userData.userName;
      }
      this.userRoll = this.users.userData.userRoll;
      switch (this.users.userData.userRoll) {
        case '1':
          this.userType = 'Super Admin';
          break;
        case '2':
          this.userType = 'Admin';
          break;
        case '3':
          this.userType = 'HR';
          break;
        case '4':
          this.userType = 'Manager';
          break;
        case '5':
          this.userType = 'Employee';
          break;
        default:
          this.userType = 'Employee';
          break;
      }
    }
    let currentDate = new Date();
    this.config = config;
    this.config.minDate = {
      year: currentDate.getFullYear() - 10,
      month: currentDate.getMonth(),
      day: currentDate.getDate(),
    };
    this.config.maxDate = { year: 2099, month: 12, day: 31 };
    this.config.markDisabled = false;
    this.loginImageURL = this.appConfig.getDefaultImgURL();
    // this.fetchPositions();
  }
  ngOnInit() {
    if (JSON.parse(localStorage.user).userData.userRoll == 3) {
      this.router.navigate(['/interested-users']);
    }
    this.initalizeUserForm();
    this.nomineeUserData();

    this.fetchuserData();
    this.fetchSkillRatingData();
    this.fetchSkillsData();
    this.getAllIBUInfo();
    this.fetchCurrentPositions();

    // this.initalizeUserForm();

    //this.userId = JSON.parse(localStorage.user).userData.userId;
    //this.getAUser(this.userId);
  }
  // /fetch user information data
  private fetchSkillRatingData() {
    this.skillRatingData = [];
    this.commonService
      .fetchSkillRatingData()
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            this.skillRatingData = data;
          } else {
            localStorage.setItem('errorMsg', 'Data Not Found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  initalizeUserForm() {
    this.userUpdatedId = 0;
    let numericRegex = /^[a-zA-Z0-9]+$/;
    let groupForm = {
      experience: ['', [Validators.required]],
      whyMove: ['', [Validators.required]],
      lastBSC: ['', [Validators.required]],
      nextPosition: [null, [Validators.required]],
      otherNextPosition: [''],
    };
    this.addUserForm = this.formBuilder.group(groupForm);
  }
  // edit user information
  private onEditSubmit(fetchuserData) {
    if (fetchuserData) {
      this.userUpdatedId = fetchuserData.userId;
      let groupForm = {
        experience: new FormControl(fetchuserData.experience),
        whyMove: new FormControl(fetchuserData.whyMove),
        lastBSC: new FormControl(fetchuserData.lastBSC),
      };
      this.addUserForm = this.formBuilder.group(groupForm);
    }
  }
  private showPrompt() {
    // this.loading = false;
    var that = this;
    setTimeout(function () {
      localStorage.setItem(
        'errorMsg',
        'Please correctly fill all the required fields'
      );
      that.commonService.showerror();
      localStorage.removeItem('errorMsg');
    }, 2000);

    // localStorage.removeItem('errorMsg');
    // return;
  }
  //close dailog box
  private closeModels() {
    this.closeModel.nativeElement.click();
  }
  private onEmailClick() {
    var email = this.selectedEmail;
    var svEmail = this.selectedSVEmail;
    // let myTag = this.el.nativeElement.querySelector(".modal-backdrop");
    // myTag.classList.remove('show');
    // this.closeModels();
    // this.showHideModel = false;
    this.commonService
      .sendEmailNiit(
        'sendRatingInvi',
        email,
        svEmail,
        'true',
        'true',
        this.selectedUserId,
        this.towerId
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          localStorage.setItem('errorMsg', 'Email sent!');
          this.commonService.showerror();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  private onAllEmailClick() {
    var email = this.selectedEmail;
    var svEmail = this.selectedSVEmail;
    // let myTag = this.el.nativeElement.querySelector(".modal-backdrop");
    // myTag.classList.remove('show');
    // this.closeModels();
    // this.showHideModel = false;
    this.commonService
      .sendEmailToAll('sendRatingInviToAll')
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          localStorage.setItem(
            'errorMsg',
            'Email has been sent to all these resources!'
          );
          this.commonService.showerror();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  // private sendEmailToAll(towerId) {
  //   this.commonService.sendEmailToAll("sendRatingInviToAll").pipe(first()).subscribe(
  //     data => {
  //       this.loading = false;
  //       localStorage.setItem('errorMsg', 'Email sent to all these resources!');
  //       this.commonService.showerror();
  //     },
  //     error => {
  //       localStorage.setItem('errorMsg', error.statusText);
  //       this.commonService.showerror();
  //       localStorage.removeItem('errorMsg');
  //     }
  //   )
  // }
  // /fetch user information data
  private fetchuserData() {
    this.loading = true;
    var userEmail = '';
    if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
      userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;
    this.commonService
      .getUsersListByPost(
        JSON.parse(localStorage.getItem('user')).userData.towerId,
        userEmail
      )
      .pipe(first())
      .subscribe(
        (data) => {
          let userIds = [];
          for (let i = 0; data && i < data.length; i++) {
            if (data[i].userId) {
              userIds.push(data[i].userId);
            }
          }
          if (userIds.length > 0) {
            this.fetchUserSkillsData(userIds, data);
            this.getAllNextPositions(
              userIds,
              JSON.parse(localStorage.user).userData.towerId
            );
          } else {
            this.loading = false;
            localStorage.setItem('errorMsg', 'Users Not Found');
            this.commonService.showerror();
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getTowersListByIbuId(ibuId, towerId, dataValue) {
    this.commonService.getTowersListByIbuId(ibuId, null).subscribe(
      (data) => {
        this.towerList = data;
        this.alltowerList = data;
        let selecteTower = this.towerList.find(
          (tower) => tower.towerId == towerId
        );
        this.selectedTowerId = selecteTower;

        console.log({ dataValue });

        if (dataValue) {
          const formTower: any = document.querySelector('#form-tower');
          if (formTower) {
            setTimeout(() => {
              formTower.value = dataValue.towerId;
              this.fetchPositions(dataValue.towerId, dataValue.positionId);
            }, 200);
          }
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private getFunctionListByIbuId(ibuId, dataValue) {
    this.functionList = [];
    this.commonService.getFunctionListByIbuId(ibuId).subscribe(
      (data) => {
        this.functionList = data;
        if (dataValue) {
          const formFunction: any = document.querySelector('#form-function');
          console.log({ dataValue, formFunction });

          if (formFunction) {
            setTimeout(() => {
              formFunction.value = dataValue.functionId;
            }, 200);
          }
        }
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private getAllIBUInfo() {
    this.loading = true;
    this.commonService
      .getAllIBUInfo()
      .pipe(first())
      .subscribe(
        (data) => {
          this.ibuList = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  private onChangeIBU(event, dataValue) {
    let ibu = dataValue ? dataValue.ibuId : event.target.value;

    if (dataValue) {
      const formIbu: any = document.querySelector('#form-ibu');

      if (formIbu) {
        formIbu.value = this.nomineeData[0].ibuId;
      }
    }

    this.resetFunctionValue();
    this.resetTowerValue();
    if (ibu) {
      this.getFunctionListByIbuId(ibu, dataValue);
      this.getTowersListByIbuId(ibu, 0, dataValue);
    } else {
      this.resetFunctionList();
      this.resetTowerList();
    }
  }

  private onChangeFunction(event) {
    let functionId = event.target.value;
    this.resetTowerValue();
    if (functionId) {
      this.towerList = this.alltowerList.filter(
        (item) => item.functionId == functionId
      );
    } else {
      this.towerList = this.alltowerList;
    }
  }
  private onChangeTower(event) {
    this.fetchPositions(event.target.value);
  }

  private resetFunctionValue() {
    this.function = '';
  }

  private resetTowerValue() {
    this.tower = '';
  }

  private resetFunctionList() {
    this.functionList = [];
  }

  private resetTowerList() {
    this.towerList = [];
  }
  // /fetch user information data
  private fetchPositions(towerId, fieldValue = '') {
    //var towerId = JSON.parse(localStorage.user).userData.towerId;
    this.commonService
      .getAllPositionInfo(towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.positionList = data;
          const formRole: any = document.querySelector('#form-other-next-role');
          if (formRole) {
            setTimeout(() => {
              formRole.value = fieldValue;
            }, 0);
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  // /fetch user information data
  private fetchCurrentPositions() {
    var towerId = JSON.parse(localStorage.user).userData.towerId;
    this.commonService
      .getAllPositionInfo(towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.currentPositionList = data;
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  private getPositionName(positionId) {
    for (let i = 0; i < this.positionList.length; i++) {
      if (this.positionList[i].positionId == positionId)
        return this.positionList[i].positionName;
    }
  }
  //fetch user skills data
  private fetchUserSkillsData(userIds: any[], userData) {
    this.commonService
      .fetchAllFunSkills(userIds)
      .pipe(first())
      .subscribe(
        (data) => {
          for (let j = 0; j < userData.length; j++) {
            let userSkill = [];
            for (let i = 0; i < data.length; i++) {
              if (userData[j].userId == data[i].userId) {
                let skillLevel = data[i].skillLevel;
                let skillName = '';
                this.skillData.forEach((litem, index) => {
                  if (litem.skillId == data[i].skillId) {
                    skillName = litem.skillName;
                  }
                });
                userSkill.push({
                  skillId: data[i].skillId,
                  skillLevel: skillLevel,
                  skillName: skillName,
                });
              }
            }
            userData[j]['userSkill'] = userSkill;
          }
          this.fetchData = userData;
          this.categoriseLeaveUsers();
          this.countActiveAndInactiveUsers();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  //fetch user skills data
  private getAllNextPositions(userIds, towerId) {
    this.commonService
      .getAllNextPositions(userIds, towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.allPositions = data;
          var that = this;
          setTimeout(function () {
            that.loading = false;
          }, 1000);
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  //categorise leave users
  private categoriseLeaveUsers() {
    for (let i = 0; i < this.fetchData.length; i++) {
      if (this.fetchData[i].leaveDate) {
        let currentDate = new Date();
        let userLeaveDate = new Date(this.fetchData[i].leaveDate);
        if (currentDate > userLeaveDate) {
          this.fetchData[i]['leaveStyle'] = 'red';
        }
      }
    }
  }
  // validate resoucre leaving date should be equal or lessthen from current date
  private countActiveAndInactiveUsers() {
    this.inactiveUserCount = 0;
    this.activeUserCount = 0;
    for (let i = 0; i < this.fetchData.length; i++) {
      let isFound = false;
      //remove user from the list if having leave date less then current date
      let currentTime = this.common.getTime(new Date());
      if (this.fetchData[i].leaveDate) {
        let leavingTime = this.common.getTime(this.fetchData[i].leaveDate);
        if (currentTime > leavingTime) {
          isFound = true;
        }
      }
      if (isFound) {
        this.inactiveUserCount++;
        this.fetchData[i]['leaveUserCSS'] = 'leaveUserCSS';
      } else {
        this.fetchData[i]['leaveUserCSS'] = '';
        this.activeUserCount++;
      }
    }
  }
  // suave user information
  private onSubmit(userFormDetails) {
    this.userFormDetails = userFormDetails;
    debugger;
    this.userFormDetails['experience'] = this.experience;
    this.userFormDetails['lastBSC'] = this.lastBSC;
    this.userFormDetails['whyMove'] = this.whyMove;
    this.userFormDetails['userId'] = JSON.parse(
      localStorage.user
    ).userData.userId;
    this.userFormDetails['nextPosition'] = this.nextPosition;
    this.userFormDetails['isApproved'] = 7; // Submitted => self nominated
    console.log('this.userFormDetails', this.userFormDetails);
    if (
      !this.userFormDetails.nextPosition ||
      this.userFormDetails.nextPosition == null ||
      this.userFormDetails.nextPosition == 'null'
    ) {
      localStorage.setItem('errorMsg', 'Please select next role');
      this.commonService.showerror();
      return;
    }
    if (!this.userFormDetails.experience) {
      localStorage.setItem('errorMsg', 'Please enter experience');
      this.commonService.showerror();
      return;
    }
    if (!this.userFormDetails.lastBSC) {
      localStorage.setItem(
        'errorMsg',
        'Please enter latest BSC score (H1 / H2)'
      );
      this.commonService.showerror();
      return;
    }
    if (!this.userFormDetails.whyMove) {
      localStorage.setItem(
        'errorMsg',
        'Please enter why you want to move to next role'
      );
      this.commonService.showerror();
      return;
    }
    if (
      this.userFormDetails.nextPosition == 'other' &&
      !this.userFormDetails.otherNextPosition
    ) {
      localStorage.setItem('errorMsg', 'Please enter other next role');
      this.commonService.showerror();
      return;
    }
    if (this.userFormDetails.nextPosition == 'other') {
      this.userFormDetails['nextPosition'] =
        this.userFormDetails.otherNextPosition;
      this.userFormDetails['otherNextPosition'] = null;
    }
    // shruti- 8/6/2020

    if (this.experience >= 24 && this.lastBSC >= 80 && this.whyMove) {
      this.nomination = true;
      this.errorNomination = false;
      this.userFormDetails['isNominated'] = 1;
      this.nomineeUserData();
      this.commonService
        .saveApplicantsData(this.userFormDetails)
        .pipe(first())
        .subscribe(
          (data) => {
            this.addUserForm.reset();
            // this.nomination = false;
            // this.router.navigate(['/selfRating']);
          },
          (error) => {
            localStorage.setItem('errorMsg', 'Must Enter all the fields');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        );
    } // && this.marked == true
    else if (this.experience && this.lastBSC && this.whyMove) {
      this.nomination = true;
      this.errorNomination = true;
      this.userFormDetails['isNominated'] = 1;
      this.nomineeUserData();
      this.commonService
        .saveApplicantsData(this.userFormDetails)
        .pipe(first())
        .subscribe(
          (data) => {
            this.addUserForm.reset();
            //this.nomination = false;
            // this.router.navigate(['/selfRating']);
          },
          (error) => {
            localStorage.setItem('errorMsg', 'Must Enter all the fields');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        );
    }
    // else if (this.marked == false) {
    //     localStorage.setItem('errorMsg', 'Please Check Eligibility Criteria');
    //     this.commonService.showerror();
    // }
    else {
      localStorage.setItem('errorMsg', 'Please fill the reuired feild');
      this.commonService.showerror();
    }
    //---------------------------
    // this.commonService.saveApplicantsData(userFormDetails).pipe(first()).subscribe(
    //   data => {
    //     this.addUserForm.reset();
    //     localStorage.setItem('errorMsg', 'Application successfully sent!');
    //     localStorage.setItem('isReload', 'true');
    //     this.commonService.showerror();
    //   },
    //   error => {
    //     localStorage.setItem('errorMsg', 'Must Enter all the fields');
    //     this.commonService.showerror();
    //     localStorage.removeItem('errorMsg');
    //   }
    //)
    // }
  }
  //check user is exits
  private isResourceExit(resourceEmail) {
    let userInfo = null;
    for (let i = 0; i < this.fetchData.length; i++) {
      if (resourceEmail == this.fetchData[i].email) {
        userInfo =
          'TR Nominee: ' + this.fetchData[i].userName + ' is already exits!';
        break;
      }
    }
    return userInfo;
  }
  //update user infromation
  private onUpdateSubmit(userFormDetails) {
    this.userFormDetails = userFormDetails;
    // if (this.addUserForm.invalid) {
    //   return;
    // }

    // if (!this.validateEmail(userFormDetails.resourceEmail)) {
    //   localStorage.setItem('errorMsg', 'Invaild Email id!');
    //   this.commonService.showerror();
    //   return
    // }
    // if (!this.validateEmail(userFormDetails.resourceManagerEmail)) {
    //   localStorage.setItem('errorMsg', 'Invaild resource manager email!');
    //   this.commonService.showerror();
    //   return
    // }
    if (userFormDetails != null && this.userUpdatedId > 0) {
      this.userFormDetails['userId'] = this.userUpdatedId;
      this.userFormDetails['joinDate'] = this.common.getDateYYMMDD(
        userFormDetails.joinDate
      );
      this.userFormDetails['leaveDate'] = this.common.getDateYYMMDD(
        userFormDetails.leaveDate
      );
      this.userFormDetails['updatedByEmail'] = this.users.emailAddress;
      this.commonService
        .updateUserData(this.userFormDetails)
        .pipe(first())
        .subscribe(
          (data) => {
            localStorage.setItem('errorMsg', 'Data Successfully Updated');
            localStorage.setItem('isReload', 'true');
            this.commonService.showerror();
            // this.router.navigateByUrl(['/admin'])
          },
          (error) => {
            localStorage.setItem('errorMsg', error.statusText);
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        );
    }
  }
  //set user skill data
  private setUserSkillData(userFormDetails: any, userId: any) {
    let userSkillData = [];
    for (let i = 0; i < this.skillData.length; i++) {
      userSkillData.push({
        userId: userId,
        skillId: Number(this.skillData[i].skillId),
        skillLevel: userFormDetails[this.skillData[i].skillName],
      });
    }
    return userSkillData;
  }
  //delete user information
  private onDeleteSubmit(userInfo) {
    userInfo['deletedByEmail'] = this.users.emailAddress;
    userInfo = this.setSkills(userInfo);
    this.commonService
      .userDeletion(userInfo)
      .pipe(first())
      .subscribe(
        (data) => {
          localStorage.setItem('errorMsg', 'Data Successfully Deleted');
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
          this.fetchuserData();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  //set skills information
  private setSkills(userInfo) {
    let userSkills = userInfo.userSkill;
    for (let i = 0; i < userSkills.length; i++) {
      if (userSkills[i].skillName) {
        userInfo[userSkills[i].skillName] = userSkills[i].skillLevel;
      } else if (userSkills[i].skillName) {
        userInfo[userSkills[i].skillName] = userSkills[i].skillLevel;
      }
    }
    return userInfo;
  }
  //fetch skills data
  private fetchSkillsData() {
    this.commonService
      .fetchSkillData()
      .pipe(first())
      .subscribe(
        (data) => {
          this.skillData = data;
          this.initalizeUserForm();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  //export resource history data
  private excelReport() {
    let excelExportData = [];
    let headers = [
      'S.No.',
      'Employee Code',
      'Employee Name',
      'Email id',
      'Current Role',
      'Target Role',
    ];

    for (let i = 0; i < this.fetchData.length; i++) {
      let data = {};
      data[headers[0]] = i + 1;
      data[headers[1]] = this.fetchData[i].empCode;
      data[headers[2]] = this.fetchData[i].userName;
      data[headers[3]] = this.fetchData[i].email;
      data[headers[4]] = this.fetchData[i].positionName;
      data[headers[5]] = this.allPositions[this.fetchData[i].userId];

      excelExportData.push(data);
    }
    this.excelService.generateExcel(headers, excelExportData, 'UserList');
  }
  private validateEmail(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  //forward to next section
  public gotoNextPage(e, routeURL) {
    this.router.navigate([routeURL]);
  }
  // logout and forward to login page
  private logout() {
    this.commonService.logout();
  }
  //shruti - 8/6/2020
  //fetch Nominee user data
  nomineeUserData() {
    var userId = JSON.parse(localStorage.user).userData.userId;
    var formDetails = {
      userid: userId,
    };
    this.commonService
      .getAUser(formDetails)
      .pipe(first())
      .subscribe(
        (data) => {
          this.addUserForm.controls['nextPosition'].setValue(
            data[0].nextPosition
          );
          this.nomineeData = data;
          console.log(data);

          // if(formIbu){
          //   console.log({formIbu})
          //   //formIbu.value = "2";
          // }

          const dataValue = {
            ibuId: this.nomineeData[0].ibuId,
            functionId: this.nomineeData[0].functionId,
            towerId: this.nomineeData[0].towerId,
            positionId: this.nomineeData[0].positionId,
          };

          setTimeout(() => {
            // const formIbu:any = document.querySelector("#form-ibu");
            // const formFunction:any = document.querySelector("#form-function");
            // const formTower:any = document.querySelector("#form-tower");
            // if(formIbu){
            //     formIbu.value = this.nomineeData[0].ibuId
            // }
            // if(formFunction){
            //   formFunction.value = this.nomineeData[0].functionId
            // }
            // if(formTower){
            //   formTower.value = this.nomineeData[0].towerId
            // }
            this.onChangeIBU(null, dataValue);
          }, 500);
          this.newNomi = this.nomineeData[0].newNomination;
          this.isAppr = this.nomineeData[0].isApproved;
          this.nextPosition = this.nomineeData[0].positionId;
          // if (this.newNomi != "" && this.isAppr == 0) {
          //     localStorage.setItem('errorMsg', "You Have Already Nominated For Role! Please Check HR Comment In View Dtails, Any Concern Contact To Your HR");
          //     this.commonService.showerror();
          //     localStorage.removeItem('errorMsg');
          //     this.router.navigate(['/selfRating']);
          // }
          // else if (this.newNomi != "" && this.isAppr == 1) {
          //     localStorage.setItem('errorMsg', "You have Already Nominated For next Role! Please contact to HR for further query");
          //     this.commonService.showerror();
          //     localStorage.removeItem('errorMsg');
          //     this.router.navigate(['/selfRating']);
          // }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  // function after nominee eligible or success to proceed
  private clickHereToProceed() {
    this.router.navigate(['/selfRating']).then(() => {
      window.location.reload();
    });
    location.reload();
    // this.nomination = false;
    // this.addUserForm.controls['experience'].disable();
    // this.addUserForm.controls['lastBSC'].disable();
  }

  private eligCriteria(e) {
    this.marked = e.target.checked;
    if (this.marked == true) {
      this.showHideModel = false;
      this.disabledNominatiobtn = false;
    } else {
      this.showHideModel = true;
      this.disabledNominatiobtn = true;
    }
  }

  onClickOK() {
    this.checkedEligiblity = true;
    this.disabledNominatiobtn = false;
  }
  /**
   * On Next Role Selection
   */
  onNextRoleSeclection(event) {
    this.addUserForm.controls['nextPosition'].setValue(event.target.value);
    this.nextPosition = event.target.value;
    this.isOtherNextRole = false;
    this.otherNextPosition = '';
    this.addUserForm.controls['otherNextPosition'].setValue('');
    if (event.target.value == 'other') {
      this.isOtherNextRole = true;
    }
  }

  /**
   * On Next Role Selection
   */
  onOtherNextRoleSeclection(event) {
    this.addUserForm.controls['otherNextPosition'].setValue(event.target.value);
  }

  /**
   * Apply validation on string by count string length.
   */
  onTextChange() {
    if (this.whyMove.length) {
      this.maxLeftCharacterWhyToMove =
        this.maxCharForWhyToMoveLength - this.whyMove.length;
      if (this.whyMove.length > this.maxCharForWhyToMoveLength) {
        this.whyMove = this.whyMove.slice(0, this.maxCharForWhyToMoveLength);
      }
    }
  }
  testModel() {
    alert('s');
    console.log(this.ibu);
  }
  test() {
    alert('s');
  }
}
